<template>
  <v-autocomplete
    v-model="selectedExpenseType"
    :outlined="outlined"
    dense
    :clearable="clearable"
    :items="expensesTypesFiltered"
    item-text="name"
    item-value="name"
    :label="lbl"
    :search-input.sync="search"
    :rules="rules"
    :hint="hint"
    :disabled="disabled"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title class="d-flex align-center">
          <span class="mr-2">{{ item.name }}</span>
          <v-chip
            x-small
            :color="item.expense_role === 'business' ? 'primary' : 'info'"
            class="mr-1"
          >
            {{ item.expense_role === 'client' ? $t('Owner') : $t('Company') }}
          </v-chip>
          <v-chip
            v-if="item.vat_rate && item.vat_rate > 0"
            x-small
            color="grey"
            text-color="white"
          >
            {{ item.vat_rate }}% VAT
          </v-chip>
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CommonFunctions from 'components/mixins/common_functions'

export default {
  mixins: [CommonFunctions],
  props: [
    'value',
    'label',
    'clearable',
    'hint',
    'outlined',
    'rules',
    'isBusinessExpense',
    'disabled',
  ],
  data() {
    return {
      selectedExpenseType: this.value,
      search: null,
    }
  },
  computed: {
    ...mapState('expenseTypes', ['expensesTypes']),
    ...mapGetters('expenseTypes', [
      'expenseTypesBusiness',
      'expenseTypesClient',
      'expenseTypesAll',
    ]),
    lbl() {
      return this.label || this.$t('Expense type')
    },
    expensesTypesFiltered() {
      if (typeof this.isBusinessExpense === 'boolean') {
        return this.isBusinessExpense
          ? this.expenseTypesBusiness
          : this.expenseTypesClient
      }
      return this.expenseTypesAll
    },
  },
  watch: {
    value(newVal) {
      this.selectedExpenseType = newVal
    },
    selectedExpenseType(newVal) {
      this.$emit('input', newVal)
    },
    isBusinessExpense() {
      this.selectedExpenseType = null
    },
  },
  created() {
    if (!this.expensesTypes.length) {
      this.fetchAllExpenseTypes()
    }
  },
  methods: {
    ...mapActions('expenseTypes', ['fetchAllExpenseTypes']),
  },
}
</script>
